import { apiService } from "../../services/ApiService";
import { porterEndpoints, endpoints } from "../../utils/endpoints";
import { DispatchMode } from "../../types";

export interface ShipmentPayload {
  orderNumbers: string[];
  additionalComments: string;
  dispatchMode?: DispatchMode;
}

export interface ShipmentResponse {
  success: boolean;
  message: string;
  data?: {
    shipmentId: string;
    customerId: string;
    supplierId: string;
    orderNumbers: string[];
    status: string;
    pickupDetails: {
      address: {
        streetAddress1: string;
        streetAddress2?: string;
        city: string;
        state: string;
        pincode: string;
        country: string;
        lat: number;
        lng: number;
        contactDetails: {
          name: string;
          phoneNumber: string;
        };
      };
    };
    dropDetails: {
      address: {
        streetAddress1: string;
        city: string;
        state: string;
        pincode: string;
        country: string;
        lat: number;
        lng: number;
        contactDetails: {
          name: string;
          phoneNumber: string;
        };
      };
    };
    createdAt: string;
    updatedAt: string;
  };
  errors?: string[];
}

export interface PorterBookingPayload {
  shipmentId: string;
}

export interface PorterBookingResponse {
  request_id: string;
  order_id: string;
  estimated_pickup_time: number;
  estimated_fare_details: any;
  tracking_url: string;
}

export const createShipment = async (
  payload: ShipmentPayload,
  skipGeocodeValidation?: boolean
): Promise<ShipmentResponse> => {
  const response = await apiService
    .axiosCruds()
    .post(endpoints.createShipment, payload, {
      params: {
        ...(skipGeocodeValidation && { skipGeocodeValidation: true }),
      },
    });

  return response.data;
};

export const bookPorter = async (payload: {
  shipmentId: string;
  maskDeliveryContactDetails?: boolean;
}) => {
  try {
    const response = await apiService
      .baseAxiosCruds()
      .post(porterEndpoints.bookPorter, payload);
    return response.data;
  } catch (error) {
    console.error("bookPorter API error:", error);
    throw error;
  }
};

export const deleteShipment = async (shipmentId: string): Promise<any> => {
  try {
    const response = await apiService
      .axiosCruds()
      .delete(endpoints.deleteShipment(shipmentId));
    return response.data;
  } catch (error) {
    throw error;
  }
};

export {};
